import React, { Component } from 'react';
import { Modal, message } from 'antd';
import FormList from '../../basicElement/FormList';
import API_URL from '../../../common/url';
import $ from '../../../common/AjaxRequest';

class Evaluation extends Component {
    state = {
        data: {},
        record: {},
        visible: false,
        loading: false,
    }

    show = (record) => {
        const {
            jdeMainCode,
            jdeCode,
            currencyName,
            exchangeRate,
            yearAmounts,
            prepaidInitialTotalLastMonthIncomeNoTax,
            prepaidCnyTotalLastMonthIncomeNoTax,
            prepaidInitialCurrentMonthIncomeNoTax,
            prepaidCnyCurrentMonthIncomeNoTax,
        } = record;
        const data = {
            jdeMainCode,
            jdeCode,
            currencyName,
            exchangeRate,
            prepaidInitialTotalLastMonthIncomeNoTax,
            prepaidCnyTotalLastMonthIncomeNoTax,
            prepaidInitialCurrentMonthIncomeNoTax,
            prepaidCnyCurrentMonthIncomeNoTax,
        };
        if (yearAmounts && yearAmounts.length) {
            yearAmounts.forEach(item => {
                const { prepaidAmount, orderInHandAmountId } = item;
                data[orderInHandAmountId] = prepaidAmount;
            });
        }
        this.setState({
            visible: true,
            record,
            data,
        });
    }

    hide = () => {
        this.setState({ visible: false });
    }

    handleChange = (value, key, type) => {
        const { data } = this.state;
        data[key] = value;
        if (key == 'siteIsStart') {
            if (value == 0) {
                data.projectApprovalTime = '';
                data.beginTime = '';
            }
        }
        this.setState({
            data,
            hasEdit: true,
        });
    }

    getColumns = () => {
        const { isCurrentMonth } = this.props;
        const { data, record } = this.state;
        const { currencyName, yearAmounts } = record;
        let currency = (currencyName || '').replace(/(\(.+\))/g, '');
        currency = (!currency || currency === '人民币') ? '元' : currency;
        
        // 字段属性配置
        const columns = [{
            name: 'JDE主项目号',
            key: 'jdeMainCode',
            type: 'text',
        }, {
            name: 'JDE项目号',
            key: 'jdeCode',
            type: 'text',
        }, {
            name: '币种',
            key: 'currencyName',
            type: 'text',
        }, {
            name: '汇率',
            key: 'exchangeRate',
            type: 'text',
        }, {
            name: '代垫费用累计上月收入不含税/原币',
            key: 'prepaidInitialTotalLastMonthIncomeNoTax',
            type: 'inputNumber',
            typeProperty: {
                unit: currency,
                precision: 2,
                style: { width: 240 },
            },
            rules: {
                required: true,
                display: isCurrentMonth,
            }
        }, {
            name: '代垫费用累计上月收入不含税/人民币',
            key: 'prepaidCnyTotalLastMonthIncomeNoTax',
            type: 'inputNumber',
            typeProperty: {
                unit: '元',
                precision: 2,
                style: { width: 240 },
            },
            rules: {
                required: true,
                display: isCurrentMonth,
            }
        }, {
            name: '代垫费用当月收入不含税/原币',
            key: 'prepaidInitialCurrentMonthIncomeNoTax',
            type: 'inputNumber',
            typeProperty: {
                unit: currency,
                precision: 2,
                style: { width: 240 },
            },
            rules: {
                required: true,
            }
        }, {
            name: '代垫费用当月收入不含税/人民币',
            key: 'prepaidCnyCurrentMonthIncomeNoTax',
            type: 'inputNumber',
            typeProperty: {
                unit: '元',
                precision: 2,
                style: { width: 240 },
            },
            rules: {
                required: true,
            }
        }];

        if (yearAmounts && yearAmounts.length) {
            yearAmounts.forEach(item => {
                const { yearNum, orderInHandAmountId } = item;
                columns.push({
                    name: `${yearNum}代垫费用在手订单额合计`,
                    key: orderInHandAmountId,
                    type: 'inputNumber',
                    typeProperty: {
                        unit: '元',
                        precision: 2,
                        style: { width: 240 },
                    },
                    rules: {
                        required: true,
                    }
                });
            });
        }

        // 字段值、显示状态配置
        const traverseColumns = function (columns) {
            columns.forEach(column => {
                const { key, type, children } = column;
                if (children) {
                    traverseColumns(children);
                } else {
                    const typeProperty = column.typeProperty || (column.typeProperty = {});
                    typeProperty.canEdit = true;
                    typeProperty.value = data[key];
                }
            });
        }
        traverseColumns(columns);

        return columns;
    }

    confirm = () => {
        const hasWritten = this.formRef.validate();
        if (!hasWritten) return;

        const { data, record } = this.state;
        const { prepaidFeeId, yearAmounts } = record;
        const {
            prepaidInitialTotalLastMonthIncomeNoTax,
            prepaidCnyTotalLastMonthIncomeNoTax,
            prepaidInitialCurrentMonthIncomeNoTax,
            prepaidCnyCurrentMonthIncomeNoTax,
        } = data;
        
        const params = {
            prepaidFeeId,
            prepaidInitialTotalLastMonthIncomeNoTax,
            prepaidCnyTotalLastMonthIncomeNoTax,
            prepaidInitialCurrentMonthIncomeNoTax,
            prepaidCnyCurrentMonthIncomeNoTax,
        };
        yearAmounts.forEach((item, index) => {
            const { orderInHandAmountId } = item;
            params[`yearAmounts[${index}].orderInHandAmountId`] = orderInHandAmountId;
            params[`yearAmounts[${index}].prepaidAmount`] = data[orderInHandAmountId];
        });

        this.setState({ loading: true });
            const options = {
                method: 'POST',
                url: API_URL.finance.savePrepaidRecord,
                data: {
                    ...params,
                },
                dataType: 'json',
                doneResult: res => {
                    if (res.success) {
                        message.success(res.success);
                    }
                    this.setState({
                        visible: false,
                        loading: false,
                    }, () => {
                        this.props.loadData();
                    });
                },
                errorResult: () => {
                    this.setState({ loading: false });
                }
            };
            $.sendRequest(options);
    }

    render() {
        const { loading, visible } = this.state;
        return (
            <Modal
                title="代垫费用收入报告赋值"
                visible={visible}
                onOk={this.confirm}
                onCancel={this.hide}
                className="create-modal"
                maskClosable={false}
                width="600px"
                confirmLoading={loading}
            >
                <FormList
                    className="form-list fortyPercentage"
                    columns={this.getColumns()}
                    onChange={this.handleChange}
                    ref={el => this.formRef = el}
                />
            </Modal>
        );
    }
}

export { Evaluation };


// WEBPACK FOOTER //
// ./src/components/financeManagement/otherChargesReport/Widget.js